import { Box3, Mesh, Object3D, Raycaster, Vector3 } from 'three';

/** Feet sit this far above the raycast hit on hull geometry. */
export const HULL_FOOT_CLEARANCE_M = 0.01;

/** Base forward placement along −Z before the depth offset (metres). */
export const HULL_CHARACTER_FORWARD_Z = -2.0;
/** Calibrated depth offset on top of {@link HULL_CHARACTER_FORWARD_Z}. */
export const HULL_CHARACTER_DEPTH_OFFSET_M = -1.25;
export const HULL_CHARACTER_SCALE = 1.7;

const _rayOrigin = new Vector3();
const _rayDir = new Vector3(0, -1, 0);
const _raycaster = new Raycaster();

/**
 * Downward ray at (x, z) through a Skybox hull. Returns the lowest hit Y
 * (floor under that column), or null if nothing was hit.
 */
export function sampleHullGroundY(hull: Object3D, x: number, z: number): number | null {
  hull.updateMatrixWorld(true);
  const meshes: Mesh[] = [];
  hull.traverse((node) => {
    const mesh = node as Mesh;
    if (mesh.isMesh) meshes.push(mesh);
  });
  if (meshes.length === 0) return null;

  const box = new Box3().setFromObject(hull);
  const originY = Number.isFinite(box.max.y) ? box.max.y + 10 : 100;
  _rayOrigin.set(x, originY, z);
  _raycaster.set(_rayOrigin, _rayDir);
  const hits = _raycaster.intersectObjects(meshes, false);
  if (hits.length === 0) return null;

  let groundY = hits[0].point.y;
  for (let i = 1; i < hits.length; i++) {
    if (hits[i].point.y < groundY) groundY = hits[i].point.y;
  }
  return groundY;
}

export function hullCharacterWorldZ(): number {
  return HULL_CHARACTER_FORWARD_Z + HULL_CHARACTER_DEPTH_OFFSET_M;
}

/** World Y for the figure root (feet) from hull raycast + optional fine-tune. */
export function hullCharacterFootY(
  hull: Object3D,
  x: number,
  z: number,
  yFineTuneM = 0,
): number {
  const ground = sampleHullGroundY(hull, x, z);
  if (ground === null) {
    console.warn('[world] hull footing: no hit under character — using y=0');
    return yFineTuneM;
  }
  return ground + HULL_FOOT_CLEARANCE_M + yFineTuneM;
}
